'use client';

import Link from 'next/link';
import { useEffect, useRef } from 'react';

import { Button } from '@/components/ui/button';

import { useDemoLogin } from '../hooks/useDemoLogin';

export function DemoLoginRunner() {
  const { isLoading, error, startDemo } = useDemoLogin();
  const startedRef = useRef(false);

  // ページ到達時に一度だけデモログインを実行する
  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    startDemo();
    // startDemo は再生成されるが初回のみ実行する
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-gradient-to-br from-blue-50 via-blue-100 to-blue-50 p-4 text-center">
        <h1 className="text-2xl font-bold text-blue-900">デモ環境に接続できませんでした</h1>
        <p className="max-w-md text-blue-800/80">{error}</p>
        <div className="flex flex-col items-center gap-3 sm:flex-row">
          <Button className="bg-blue-600 hover:bg-blue-700" asChild>
            <Link href="/signup">無料で始める</Link>
          </Button>
          <Button variant="outline" asChild>
            <Link href="/">トップへ戻る</Link>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-gradient-to-br from-blue-50 via-blue-100 to-blue-50 p-4 text-center">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-blue-300 border-t-transparent" />
      <p className="text-blue-800/80">
        {isLoading ? 'デモ環境を準備しています...' : 'デモ環境へ移動しています...'}
      </p>
    </div>
  );
}
